import React, { useState } from "react";
import { Button, Col, Divider, Input, Row } from "antd";
import { useDispatch, useSelector } from "react-redux";

import { ApplicationsActions, selectIsReviewKycLoading } from "@redux";
import { i18, trb } from "@utilities";

export const PPPApproveKyc = React.memo(({ appId }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectIsReviewKycLoading);

  const [reviewKycStatusComment, setReviewKycStatusComment] = useState("");

  const handleCheckKycClick = async reviewKyc => {
    try {
      await dispatch(
        ApplicationsActions.setReviewKycStatus(
          appId,
          {
            reviewKyc,
            comment: reviewKycStatusComment
          },
          i18.NotificationTitles.KycReviewedSuccessfully
        )
      );
    } catch (e) {
      setReviewKycStatusComment("");
    }
  };

  return (
    <>
      <Divider />
      <Row>
        <Col span={24} className="mt-3 d-flex">
          <Button
            htmlType="submit"
            onClick={() => handleCheckKycClick(false)}
            type="primary"
            disabled={isLoading || reviewKycStatusComment}
            className="mr-2"
            loading={isLoading}
          >
            {`${trb(i18.Buttons.KycDocumentApprove)}`}
          </Button>
          <Button
            htmlType="submit"
            onClick={() => handleCheckKycClick(true)}
            type="secondary"
            className="mr-2"
            disabled={!reviewKycStatusComment || isLoading}
          >
            {`${trb(i18.Buttons.KycDocumentNeedWork)}`}
          </Button>
          <Input
            onChange={e => setReviewKycStatusComment(e.target.value)}
            placeholder={trb(i18.ApplicationsLabels.CheckDocumentNeedWorkComment)}
            className="w-100"
          />
        </Col>
      </Row>
    </>
  );
});
